export const SOCIAL_MEDIA_ENUM = {
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram"
};
